import React, { useState } from 'react'
import { Button, WithPopover } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { MoreActionsItemName } from '../useMoreSaleActions'
import { LineItemUser } from '../../../models/line-item'
import { MoreActionsPopover } from './MoreActionsPopover'

type Props = {
  shouldDisableActions: boolean
  moreActionsItemHandler: (
    data: MoreActionsItemName,
    user?: LineItemUser
  ) => void
}
export const MoreActions = (props: Props) => {
  const { shouldDisableActions, moreActionsItemHandler } = props
  const [isOpen, setIsOpen] = useState(false)
  const togglePopover = () => setIsOpen(!isOpen)
  const closePopover = () => setIsOpen(false)

  /**
   * Handle click event on the popover
   * Then close the popover
   */
  const clickHandler = (item: MoreActionsItemName, user?: LineItemUser) => {
    moreActionsItemHandler(item, user)
    closePopover()
  }

  return (
    <WithPopover className="vd-popover--with-list" direction="bottomLeft">
      <Button
        modifier="text"
        variant="supplementary"
        onClick={togglePopover}
        disabled={shouldDisableActions}
        data-cy={'more-actions-button'}
        data-track="more-actions-button"
      >
        <i className="fa fa-caret-down vd-mr1"></i>
        <span className="wr-hide-on-mobile">
          <T _str="More actions…" _context="Desktop more actions button" />
        </span>
        <span className="wr-hide-above-mobile">
          <T _str="More" _context="Mobile more actions button" />
        </span>
      </Button>
      {isOpen && (
        <MoreActionsPopover
          closePopover={closePopover}
          shouldDisableActions={shouldDisableActions}
          clickHandler={clickHandler}
        />
      )}
    </WithPopover>
  )
}
